import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ca6024a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "total-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, field => {
    return _openBlock(), _createBlock(_component_b_td, {
      key: field.key,
      class: _normalizeClass([{
        ['b-table-sticky-column']: $options.isTotalColumn(field)
      }])
    }, {
      default: _withCtx(() => [_createVNode(_component_hug_value, {
        class: "total-element",
        styles: {
          justifyContent: field.justify,
          padding: '8px'
        },
        loading: $props.loading
      }, {
        default: _withCtx(() => [$options.isTotalColumn(field) ? (_openBlock(), _createElementBlock("span", _hoisted_1, "TOTAL")) : _createCommentVNode("", true), field.key === 'sponsored_sales' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 1,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`],
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total.sponsored_sales
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'spend' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 2,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`],
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total.spend
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'big_sponsored_sales' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 3,
          value: $props.total.sponsored_sales
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'big_spend' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 4,
          value: $props.total.spend
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'clicks' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 5,
          value: $props.total.clicks,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'ACOS' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 6,
          value: $props.total.ACOS
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'TACOS' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 7,
          value: $props.total.TACOS
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'units_sold_clicks_14_d' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 8,
          value: $props.total.units_sold_clicks_14_d,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'ROAS' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 9,
          value: $props.total.ROAS,
          precision: 1,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'CPC' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 10,
          value: $props.total.CPC,
          precision: 2,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'CVR' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 11,
          value: $props.total.CVR,
          limit: 0.1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'sponsored_asin' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 12,
          value: $props.total.sponsored_asin,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'keyword_bid' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 13,
          value: $props.total.keyword_bid,
          precision: 2
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'share_sponsored_sales' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 14,
          value: $props.total.share_sponsored_sales
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'percent_time_in_budget' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 15,
          value: $props.total.percent_time_in_budget
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'CTR' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 16,
          value: $props.total.CTR,
          limit: 0.1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'impressions' ? (_openBlock(), _createBlock(_component_number_value, {
          key: 17,
          value: $props.total.impressions,
          styles: {
            padding: 0
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["styles", "loading"])]),
      _: 2
    }, 1032, ["class"]);
  }), 128);
}